import React from 'react'
import { connect } from 'react-redux'
import PageTitle from '../components/page-title'
import WelcomeImages from '../components/welcome-images'
import { welcomeNames } from '../selectors/client'

const mapStateToProps = (state, ownProps) => {
  return {
    names: welcomeNames(state)
  }
}

const titleStyle = {
  zIndex: 2,
  position: 'relative'
}

const Welcome = props => {
  const renderPageTitle = () => {
    let subtitle = 'Thank you for choosing Kimberfire.'
    if (props.names) {
      return (
        <PageTitle title='Welcome' subtitle={subtitle} lg>
          {props.names}
        </PageTitle>
      )
    } else {
      return <PageTitle subtitle={subtitle} lg>Welcome</PageTitle>
    }
  }

  return (
    <div>
      <div style={titleStyle}>
        {renderPageTitle()}
      </div>
      <WelcomeImages />
    </div>
  )
}

export default connect(mapStateToProps)(Welcome)



// WEBPACK FOOTER //
// ./src/containers/welcome.js